(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belstarter-search-prices"]) return;
  try {
    
  (() => {
    const configElement = document.getElementById('belstarter-search-price-config');
    if (!configElement || window.belstarterSearchPricesMounted) return;

    let config;
    try {
      config = JSON.parse(configElement.textContent);
    } catch (_) {
      return;
    }

    window.belstarterSearchPricesMounted = true;
    document.documentElement.classList.add('belstarter-search-prices-active');

    const cardSelector = '.rps-product-container, .belstarter-product-card';
    const states = new WeakMap();
    const cache = new Map();
    const queue = [];
    const ttl = 30000;
    let running = 0;
    let scheduled = false;
    let generation = 0;

    const normalizeSku = value => String(value || '').trim().toUpperCase();

    function descriptor(card) {
      const link = card.matches('a[href*="/products/"]')
        ? card
        : card.querySelector('a[href*="/products/"]');
      if (!link) return null;

      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (_) {
        return null;
      }
      if (url.origin !== window.location.origin) return null;
      const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      if (!match) return null;

      let handle;
      try {
        handle = decodeURIComponent(match[1]);
      } catch (_) {
        return null;
      }
      const root = String(config.root || '/').replace(/\/?$/, '/');
      const endpoint = new URL(root + 'products/' + encodeURIComponent(handle), window.location.origin);
      const variant = url.searchParams.get('variant');
      if (variant && /^\d+$/.test(variant)) endpoint.searchParams.set('variant', variant);
      endpoint.searchParams.set('section_id', config.section);

      const skuNode = card.querySelector('.rps-product-sku, .belstarter-product-card__sku');
      const sku = normalizeSku(skuNode ? skuNode.textContent.replace(/^(?:SKU|Cod)\s*:\s*/i, '') : '');
      return { url, endpoint, handle, variant, sku, key: endpoint.href + '|' + sku };
    }

    function message(card, state, text, href) {
      state.panel.replaceChildren();
      state.panel.setAttribute('aria-busy', 'false');
      const element = document.createElement(card.matches('a') || !href ? 'span' : 'a');
      element.className = 'belstarter-search-offer__link';
      element.textContent = text;
      if (element.tagName === 'A') element.href = href;
      state.panel.appendChild(element);
    }

    function insertPanel(card) {
      card.querySelectorAll('.belstarter-search-offer').forEach(element => element.remove());
      const panel = document.createElement('div');
      panel.className = 'belstarter-search-offer';
      panel.setAttribute('aria-busy', 'true');
      panel.textContent = config.loading;
      const position = card.querySelector('.rps-product-sku, .belstarter-product-card__sku') || card.querySelector('.rps-product-title, .belstarter-product-card__title');
      if (position && position !== card) position.insertAdjacentElement('afterend', panel);
      else card.appendChild(panel);
      return panel;
    }

    function stillCurrent(card, state) {
      if (!card.isConnected || states.get(card) !== state || state.generation !== generation) return false;
      const current = descriptor(card);
      return current && current.key === state.item.key && state.panel.isConnected;
    }

    async function request(item) {
      const key = item.endpoint.href;
      const existing = cache.get(key);
      if (existing && Date.now() - existing.at < ttl) return existing.promise;
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), 10000);
      const url = new URL(key);
      url.searchParams.set('_bel_price_request', String(Date.now()));
      const entry = { at: Date.now(), promise: null };
      entry.promise = (async () => {
        try {
          const response = await fetch(url.href, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal,
            headers: { Accept: 'text/html' }
          });
          if (!response.ok) throw new Error('Price response unavailable');
          const finalUrl = new URL(response.url || url.href, window.location.origin);
          if (finalUrl.origin !== window.location.origin || finalUrl.pathname !== url.pathname) {
            throw new Error('Price request redirected');
          }

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = documentFragment.querySelector('template[data-belstarter-price-response]');
          if (!payload || payload.dataset.version !== '1' || payload.dataset.authorized !== 'true') {
            throw new Error('No authorized price');
          }
          if (payload.dataset.company !== String(config.company)
            || payload.dataset.location !== String(config.location)
            || payload.dataset.currency !== config.currency
            || payload.dataset.product !== item.handle) {
            throw new Error('Price context mismatch');
          }

          const price = payload.content.querySelector('[data-belstarter-price]');
          const stock = payload.content.querySelector('[data-belstarter-stock]');
          const locations = payload.content.querySelector('[data-belstarter-availability]');
          return {
            subtitle: typeof payload.dataset.subtitle === 'string' ? {
              format: 'belstarter-subtitle-v1',
              id: payload.dataset.productId || '',
              handle: payload.dataset.product,
              subtitle: payload.dataset.subtitle
            } : null,
            sku: normalizeSku(payload.dataset.sku),
            variant: payload.dataset.variant,
            price: price ? price.textContent.trim() : '',
            locations,
            stock: stock ? stock.textContent.trim() : '',
            stockStatus: stock ? stock.dataset.belstarterStock : ''
          };
        } catch (error) {
          if (cache.get(key) === entry) cache.delete(key);
          throw error;
        } finally {
          window.clearTimeout(timer);
        }
      })();
      cache.set(key, entry);
      if (cache.size > 100) cache.delete(cache.keys().next().value);
      return entry.promise;
    }

    async function loadCard(card, state) {
      try {
        const data = await request(state.item);
        if (!stillCurrent(card, state)) return;
        if (state.item.sku && data.sku !== state.item.sku) throw new Error('SKU mismatch');
        if (state.item.variant && data.variant !== state.item.variant) throw new Error('Variant mismatch');

        if (data.subtitle) {
          card.dataset.belstarterSubtitleResponse = JSON.stringify(data.subtitle);
          delete card.dataset.belstarterSubtitleFallback;
          card.dispatchEvent(new CustomEvent('belstarter:subtitle-ready', { bubbles: true }));
        }

        state.panel.replaceChildren();
        state.panel.setAttribute('aria-busy', 'false');
        if (data.price) {
          const price = document.createElement('span');
          price.className = 'belstarter-search-offer__price';
          price.textContent = data.price;
          state.panel.appendChild(price);
        } else {
          message(card, state, config.quote, state.item.url.href);
        }

        if (data.locations) {
          state.panel.appendChild(data.locations.cloneNode(true));
        } else if (data.stock) {
          const stock = document.createElement('span');
          stock.className = 'belstarter-search-offer__stock';
          stock.dataset.status = data.stockStatus;
          stock.textContent = data.stock;
          state.panel.appendChild(stock);
        }
      } catch (_) {
        if (stillCurrent(card, state)) {
          message(card, state, config.details, state.item.url.href);
          card.dataset.belstarterSubtitleFallback = state.item.url.pathname.replace(/\/$/, '');
          card.dispatchEvent(new CustomEvent('belstarter:subtitle-fallback', { bubbles: true }));
        }
      }
    }

    function drain() {
      while (running < 4 && queue.length) {
        const { card, state } = queue.shift();
        if (!stillCurrent(card, state)) continue;
        running += 1;
        loadCard(card, state).finally(() => {
          running -= 1;
          drain();
        });
      }
    }

    function enqueue(card) {
      const state = states.get(card);
      if (!state || state.queued || !stillCurrent(card, state)) return;
      state.queued = true;
      queue.push({ card, state });
      drain();
    }

    const intersection = 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          intersection.unobserve(entry.target);
          enqueue(entry.target);
        });
      }, { rootMargin: '200px' })
      : null;

    function scan() {
      scheduled = false;
      document.querySelectorAll(cardSelector).forEach(card => {
        const item = descriptor(card);
        if (!item) return;
        const previous = states.get(card);
        if (previous && previous.item.key === item.key && previous.panel.isConnected
          && previous.generation === generation) return;

        const state = { item, panel: insertPanel(card), queued: false, generation };
        states.set(card, state);
        if (!config.enabled) {
          message(card, state, config.login, config.loginUrl);
        } else if (intersection) {
          intersection.observe(card);
        } else {
          enqueue(card);
        }
      });
    }

    function scheduleScan() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(scan);
    }

    const mutation = new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return !target || !target.closest('.belstarter-search-offer');
      })) scheduleScan();
    });
    mutation.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      generation += 1;
      queue.length = 0;
      cache.clear();
      scheduleScan();
    });

    window.addEventListener('pageshow', event => {
      if (event.persisted) window.location.reload();
    });

    scan();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
